const About = () => {
    return ( 
        <div className="container-fluid py-4 px-4 bg-harsh vh-100">

            <h1 className="text-center text-orange-a d-none d-lg-block page-header">About Me</h1>
            
            <div className="row mobile mt-5">
                <div className="col-12 col-lg-4 img-div text-center mb-4">
                    <img src="/images/profile32.jpg" className="img-fluid circle-image" alt="Profile" />
                    <h4 className="text-orange-a mt-4">Software Developer</h4>
                </div>
                <div className="col-12 col-lg-8 my-4 orange-marker about-details">
                    <h4 className="text-orange-a mt-5">Dare Afolabi</h4>
                    <p className="text-grey-a">An experienced software developer.</p>
                    <p className="text-grey-a">Experienced in HTML, CSS, Javascript, Bootstrap, Node.Js, React.Js Typescript, Python...</p>
                </div>
            </div>

        </div>
    );
}

export default About;